<template>
  <CTag :color="tag.colorHex ?? undefined" v-tooltip="tooltip" class="c-dossier-tag" :class="`c-dossier-tag-${display}`">
    <CIcon :name="tag.isPause ? 'pause' : 'flag'" :size="display === 'small' || display === 'small-text' ? 12 : 16"/>
    <CEllipsis v-if="display === 'full' || display === 'small-text'" noTitle>{{ tag.description }}</CEllipsis>
    <template v-else-if="display === 'abbreviated'">{{ tag.getAbbreviation() }}</template>
  </CTag>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import ReferenceService from '@/general/services/ReferenceService';
  import CEllipsis from '@/shared/components/CEllipsis.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CTag from '@/shared/components/CTag.vue';
  import Tag from '@/shared/models/Tag';
  import { formatCreationInfo } from '@/shared/utils/format';
  import { isTruthy } from '@/shared/utils/typescript';

  export type Display = 'full' | 'abbreviated' | 'icon' | 'small' | 'small-text';

  const props = withDefaults(defineProps<{
    tag: Tag,
    display?: Display,
  }>(), {
    display: 'full',
  });

  const tooltip = computed(() => [
    props.tag.description,
    formatCreationInfo({ createdBy: ReferenceService.getUser(props.tag.createdBy?.id), createdOn: props.tag.createdOn })]
    .filter(isTruthy)
    .join(' • '));
</script>

<style lang="scss">
.c-dossier-tag {
  &-small-text {
    height: 20px;
    font-size: .85rem;
    line-height: 1.125;
  }
}
</style>
